import apiClient from './apiClient';
import type { AllTrainingPlans } from '@/types/planTypes';

export const getAllTrainingPlans = async (): Promise<AllTrainingPlans[]> => {
  const response = await apiClient.get('trainingPlans');
  return response.data as AllTrainingPlans[];
};
